import React from "react";
import {Column, Container, Icon, TechnologyItem, TechnologyItemWrapper, TechnologyWrapper, Text, TextBox, Title, Wrapper,} from "./styles";

export const Technologies = ({data}) => {
  return (
    <Container>
      <Wrapper>
        <Column>
          <TextBox>
            <Title>{data.title}</Title>
            <Text>{data.text}</Text>
          </TextBox>
        </Column>
        <Column>
          <TechnologyWrapper>
            {data.icons.map((item, i) => (
              <TechnologyItemWrapper key={i}>
              <TechnologyItem >
              <Icon src={item.icon} alt={`ikona - ${item.title}`}/>
              </TechnologyItem>
              </TechnologyItemWrapper>
            ))}
          </TechnologyWrapper>
        </Column>
      </Wrapper>
    </Container>
  );
};
